/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Calendar_MoreInputs */

const en_us2_progress_extra_calendar_more = /** @type {(inputs: Progress_Extra_Calendar_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`more volume`)
};

const pt_br2_progress_extra_calendar_more = /** @type {(inputs: Progress_Extra_Calendar_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mais volume`)
};

const es_419_progress_extra_calendar_more = /** @type {(inputs: Progress_Extra_Calendar_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`más volumen`)
};

const pt_pt2_progress_extra_calendar_more = /** @type {(inputs: Progress_Extra_Calendar_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mais volume`)
};

const fr_fr2_progress_extra_calendar_more = /** @type {(inputs: Progress_Extra_Calendar_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plus de volume`)
};

const de_de2_progress_extra_calendar_more = /** @type {(inputs: Progress_Extra_Calendar_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mehr Volumen`)
};

const it_it2_progress_extra_calendar_more = /** @type {(inputs: Progress_Extra_Calendar_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`più volume`)
};

/**
* | output |
* | --- |
* | "more volume" |
*
* @param {Progress_Extra_Calendar_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_calendar_more = /** @type {((inputs?: Progress_Extra_Calendar_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Calendar_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_calendar_more(inputs)
	if (locale === "es-419") return es_419_progress_extra_calendar_more(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_calendar_more(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_calendar_more(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_calendar_more(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_calendar_more(inputs)
	return en_us2_progress_extra_calendar_more(inputs)
});
export { progress_extra_calendar_more as "progress-extra.calendar_more" }